<template>
  <div class="row pt-2">
    <div class="col">
      <Button label="Modifier" v-on:click="modifier"/>
    </div>
    <div class="col">
      <Button label="Fermer" v-on:click="fermer"/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ButtonBar',
  emits: ['fermer'],
  methods: {
    modifier() {
      this.$router.push({
        name: "modifierEvaluation",
        params: {
          cle: this.$route.params.cle,
          site: this.$route.params.site
        },
      });
    },
    fermer() {
      this.$emit('fermer');
    },
  }
}
</script>